import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  CONSTANTE_ERROR_AL_AVISAR_AL_RECEPTOR,
  CONSTANTE_ERROR_DE_VALIDACION_DE_PIN,
  CONSTANTE_ESTADO_CANCELADO,
  CONSTANTE_ESTADO_CERRADO_POR_EMISOR,
  CONSTANTE_ESTADO_DE_TIEMPO_EXPIRADO,
  CONSTANTE_ESTADO_ENVIANDO,
  CONSTANTE_ESTADO_EN_CURSO,
  CONSTANTE_ESTADO_ERROR_EN_ENVIO,
  CONSTANTE_ESTADO_FINALIZADO,
  CONSTANTE_ESTADO_FINALIZADO_VERSION_NUEVA_HOST,
  CONSTANTE_ESTADO_KO,
  CONSTANTE_ESTADO_OK,
  CONSTANTE_ESTADO_PENDIENTE_CANCELACION,
  CONSTANTE_ESTADO_PENDIENTE_CERTIFICADOS,
  CONSTANTE_ESTADO_PENDIENTE_CERTIFICADOS_DR,
  CONSTANTE_ESTADO_PENDIENTE_CERTIFICADO_POSTAL,
  CONSTANTE_ESTADO_PENDIENTE_ENVIAR,
  CONSTANTE_FORMATO_DE_PETICION_ERRONEO,
} from '@app/@core/constants/users.constants';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { ProfileDTO } from '@app/user-profiles/model/user-profiles-model';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import {
  AttachDocumentDTO,
  BrandMaintenanceDTO,
  RequestEcommerceReportDTO,
  UserDTO,
  WhitelistDTO,
  PasswordPoliciesDTO,
  EcommerceReportDTO,
  RequestEcommerceDetailReportDTO,
  EcommerceReportDetailDTO,
  RequestEcommerceDetailTPVReportDTO,
  DetailEcommerceTPVReportDTO,
  ResponseCombosAdministratorReportDTO,
  RequestAdministratorReportDTO,
  CombosReportResponseDTO,
  RequestDigitalSignatureReportDTO,
  DigitalSignatureResponseDTO,
  RequestCancelSignatureDTO,
  RequestUpdateStatesDTO,
  RequestCertificateDTO,
  CertificateResponseDTO,
  RequestDivisionDTO,
  RequestDetailUsersDTO,
  ResponseDetailUsersDTO,
  RequestUsersByFilterDTO,
  RequestActionDTO,
  RequestBrandDTO,
  ResponseBrandDTO,
  RequestAttributionsByProfileDTO,
  ResponseAttributionsByProfileDTO,
  ResponsePasswordDTO,
  RequestCreateUsersDTO,
  RequestVendorByFilterDTO,
  UserDetailRequestDTO,
  UserDetailResponseDTO,
  RequestDeleteUsersDTO,
  RequestModifyUsersDTO,
  ResponseImpersonatedUserDTO,
  RequestImpersonatedUserDTO,
} from '../model/users-model';
import { AdminServiceApi } from './admin-service-api.service';

@Injectable()
export class AdminStore {
  constructor(
    private adminServiceApi: AdminServiceApi,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {}

  public loadEntities(): Observable<CommonDataDTO[]> {
    return this.adminServiceApi.postGetEntities();
  }

  public loadEntitiesPrescriptorsChain(entity: WhitelistDTO): Observable<WhitelistDTO[]> {
    return this.adminServiceApi.postGetWhileList(entity);
  }

  public deleteFromEntity(whiteList: WhitelistDTO): Promise<any> {
    return new Promise<boolean>((resolve, reject) => {
      this.adminServiceApi
        .postDeleteWhileList(whiteList)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getPrescriptorsChain(searchUserId: string): Promise<any> {
    let whiteList: WhitelistDTO = {
      entityId: 'null',
      userId: searchUserId,
    };
    return new Promise<any>((resolve, reject) => {
      this.adminServiceApi
        .postGetWithoutWhiteList(whiteList)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public createSolution(user: UserDTO, entityId: string): Promise<any> {
    let whiteList: WhitelistDTO = {
      entityId: entityId,
      userId: user.userId,
    };
    return new Promise<any>((resolve, reject) => {
      this.adminServiceApi
        .postCreateWhiteList(whiteList)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public createBrandMaintenance(file: AttachDocumentDTO, form: FormGroup): Promise<any> {
    let brandMaintenanceDTO: BrandMaintenanceDTO = {
      attachDocumentsDTO: file,
      brand: form.get('brand')?.value,
      language: form.get('language')?.value,
      highBeneficiary: form.get('beneficiary')?.value,
      numMaxBeneficiary: form.get('numBeneficiary')?.value,
      highPurchase: form.get('withShopping')?.value,
      highNoPurchase: form.get('withoutShopping')?.value,
      highEmplCode: form.get('codWorker')?.value,
      highRefCode: form.get('codReference')?.value,
      highInsurance: form.get('insurance')?.value,
      postalCodeNor: form.get('postalCode')?.value,
      discountPercentage: form.get('discount')?.value,
      corporateColor: form.get('color')?.value,
    };
    return new Promise<any>((resolve, reject) => {
      this.adminServiceApi.postCreateBrandMaintenance(brandMaintenanceDTO).subscribe(
        (response) => (response ? resolve(response) : reject(response)),
        (error) => reject(error)
      );
    });
  }

  public getReportsECommerce(eCommerceForm: FormGroup): Promise<EcommerceReportDTO[]> {
    const requestEcommerceReportDTO: RequestEcommerceReportDTO = {
      operationNumber: eCommerceForm.get('numOperation')?.value,
      nifNie: eCommerceForm.get('nif')?.value?.toUpperCase(),
      idEcommerce: eCommerceForm.get('idEcommerce')?.value,
      name: eCommerceForm.get('name')?.value?.toUpperCase(),
      lastName1: eCommerceForm.get('firstName')?.value?.toUpperCase(),
      lastName2: eCommerceForm.get('lastName')?.value?.toUpperCase(),
      guid: eCommerceForm.get('guid')?.value,
      initDate: eCommerceForm.get('initialDate')?.value
        ? this.datePipe.transform(eCommerceForm.get('initialDate')?.value, 'dd/MM/yyyy')
        : '',
      endDate: eCommerceForm.get('finalDate')?.value
        ? this.datePipe.transform(eCommerceForm.get('finalDate')?.value, 'dd/MM/yyyy')
        : '',
      updDate: eCommerceForm.get('dateUpdate')?.value
        ? this.datePipe.transform(eCommerceForm.get('dateUpdate')?.value, 'dd/MM/yyyy')
        : '',
    };
    return new Promise<EcommerceReportDTO[]>((resolve, reject) => {
      this.adminServiceApi.getReportsECommerce(requestEcommerceReportDTO).subscribe(
        (response) => (response ? resolve(response) : reject(response)),
        (error) => reject(error)
      );
    });
  }

  public getReportsDetailECommerce(reportEcommerce: EcommerceReportDTO): Promise<EcommerceReportDetailDTO> {
    const requestEcommerceDetailReportDTO: RequestEcommerceDetailReportDTO = {
      idEcommerce: reportEcommerce.idEcommerce,
      operationNumber: reportEcommerce.numOperacion,
      guid: reportEcommerce.guid,
      numContract: reportEcommerce.numContract,
      orderReference: reportEcommerce.orderReference,
      channel: reportEcommerce.channel,
    };
    return new Promise<EcommerceReportDetailDTO>((resolve, reject) => {
      this.adminServiceApi.getDetailECommerce(requestEcommerceDetailReportDTO).subscribe(
        (response) => (response ? resolve(response) : reject(response)),
        (error) => reject(error)
      );
    });
  }

  public getReportsDetailTPVECommerce(reportEcommerce: EcommerceReportDTO): Promise<DetailEcommerceTPVReportDTO> {
    const requestEcommerceDetailReportDTO: RequestEcommerceDetailTPVReportDTO = {
      idEcommerce: reportEcommerce.idEcommerce,
      guid: reportEcommerce.guid,
      orderCode: '',
      fuc: null,
      codeAuthorization: reportEcommerce.codAutorization,
    };

    return new Promise<DetailEcommerceTPVReportDTO>((resolve, reject) => {
      this.adminServiceApi.getDetailECommerceTPV(requestEcommerceDetailReportDTO).subscribe(
        (response) => (response ? resolve(response) : reject(response)),
        (error) => reject(error)
      );
    });
  }

  public getPasswordPolicies(): Promise<PasswordPoliciesDTO> {
    return new Promise<PasswordPoliciesDTO>((resolve, reject) => {
      this.adminServiceApi.getPasswordPolicies().subscribe(
        (response) => (response ? resolve(response) : reject(response)),
        (error) => reject(error)
      );
    });
  }

  public getCombosReportAdministrator(): Promise<ResponseCombosAdministratorReportDTO> {
    return new Promise<ResponseCombosAdministratorReportDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetCombosReportAdministrator()
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getCombosReportSignature(): Promise<CombosReportResponseDTO> {
    return new Promise<CombosReportResponseDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetCombosReportSignature()
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public resultsSignatureReport(data: FormGroup): Promise<DigitalSignatureResponseDTO> {
    let RequestSignatureReportDTO: RequestDigitalSignatureReportDTO = {
      operationNumber: data.controls.numOperation.value,
      nifNie: data.controls.nif.value,
      guid: data.controls.guid.value,
    };

    return new Promise<DigitalSignatureResponseDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetResultsSignatureReport(RequestSignatureReportDTO)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public cancelSignatureINE(data: RequestCancelSignatureDTO): Promise<DigitalSignatureResponseDTO> {
    return new Promise<DigitalSignatureResponseDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetCancelSignatureINE(data)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public cancelSignatureContract(data: RequestCancelSignatureDTO): Promise<DigitalSignatureResponseDTO> {
    return new Promise<DigitalSignatureResponseDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetCancelSignatureContract(data)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  // public updateStates(data: RequestUpdateStatesDTO): Promise<DigitalSignatureResponseDTO> {
  //   return new Promise<DigitalSignatureResponseDTO>((resolve, reject) => {
  //     this.adminServiceApi
  //       .postGetUpdateStates(data)
  //       .toPromise()
  //       .then(
  //         (data) => {
  //           resolve(data);
  //         },
  //         (error) => {
  //           console.log(error);
  //           reject(error);
  //         }
  //       );
  //   });
  // }

  public printCertificate(data: RequestCertificateDTO): Promise<CertificateResponseDTO> {
    return new Promise<CertificateResponseDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetCertificate(data)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public resultsAdminReport(data: FormGroup): Promise<RequestAdministratorReportDTO> {
    let requestAdministratorReportDTO: RequestAdministratorReportDTO = {
      userHost: data.controls.codHost.value,
      divisionId: data.controls.division.value,
      typeBS: data.controls.typeBS.value,
      userClassNum: data.controls.perfil.value,
      attribution: data.controls.attribution.value,
      registerDateFrom: data.controls.dateInit.value
        ? this.datePipe.transform(data.controls.dateInit.value, 'yyyyMMdd')
        : '',
      registerDateTo: data.controls.dateEnd.value
        ? this.datePipe.transform(data.controls.dateEnd.value, 'yyyyMMdd')
        : '',
      dropDateFrom: data.controls.dateInitLow.value
        ? this.datePipe.transform(data.controls.dateInitLow.value, 'yyyyMMdd')
        : '',
      dropDateTo: data.controls.dateEndLow.value
        ? this.datePipe.transform(data.controls.dateEndLow.value, 'yyyyMMdd')
        : '',
      internalCommercialUserId: data.controls.internal.value,
      externalCommercialUserId: data.controls.external.value,
      office: data.controls.office.value,
      activated: data.controls.active.value === '' ? null : data.controls.active.value,
      order1: data.controls.orden1.value,
      order2: data.controls.orden2.value,
      order3: data.controls.orden3.value,
    };

    return new Promise<RequestAdministratorReportDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetResultsAdminReport(requestAdministratorReportDTO)
        .toPromise()
        .then(
          (data: RequestAdministratorReportDTO) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  getTextStatus(state: string): string {
    let text: string;
    switch (state) {
      case CONSTANTE_ESTADO_OK:
        text = 'OK';
        break;
      case CONSTANTE_ESTADO_KO:
        text = 'KO';
        break;
      case CONSTANTE_ESTADO_PENDIENTE_CERTIFICADOS_DR:
        text = 'PENDIENTE CERTIFICADO';
        break;
      case CONSTANTE_FORMATO_DE_PETICION_ERRONEO:
        text = 'FORMATO DE PETICIÓN ERRONEO';
        break;
      case CONSTANTE_ERROR_AL_AVISAR_AL_RECEPTOR:
        text = 'ERROR AL AVISAR AL RECEPTOR';
        break;
      case CONSTANTE_ERROR_DE_VALIDACION_DE_PIN:
        text = 'ERROR VALIDACIÓN PIN';
        break;
      case CONSTANTE_ESTADO_DE_TIEMPO_EXPIRADO:
        text = 'TIEMPO EXPIRADO';
        break;
      case CONSTANTE_ESTADO_CERRADO_POR_EMISOR:
        text = 'ESTADO CERRADO POR EMISOR';
        break;
      case CONSTANTE_ESTADO_PENDIENTE_ENVIAR:
        text = 'PENDIENTE DE ENVIAR';
        break;
      case CONSTANTE_ESTADO_ENVIANDO:
        text = 'ENVIANDO';
        break;
      case CONSTANTE_ESTADO_EN_CURSO:
        text = 'EN CURSO';
        break;
      case CONSTANTE_ESTADO_FINALIZADO:
        text = 'EFINALIZADO';
        break;
      case CONSTANTE_ESTADO_ERROR_EN_ENVIO:
        text = 'ERROR ENVÍO';
        break;
      case CONSTANTE_ESTADO_PENDIENTE_CERTIFICADOS:
        text = 'PENDIENTE CERTIFICADOS';
        break;
      case CONSTANTE_ESTADO_PENDIENTE_CERTIFICADO_POSTAL:
        text = 'PENDIENTE CERTIFICADO POSTAL';
        break;
      case CONSTANTE_ESTADO_FINALIZADO_VERSION_NUEVA_HOST:
        text = 'FINALIZADO VERSION NUEVA HOST';
        break;
      case CONSTANTE_ESTADO_PENDIENTE_CANCELACION:
        text = 'PENDIENTE CANCELACIÓN';
        break;
      case CONSTANTE_ESTADO_CANCELADO:
        text = 'CANCELADO';
        break;
    }
    return text;
  }

  public getExternalCommercial(division: RequestDivisionDTO) {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .postGetExternalCommercial(division)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getDivisions() {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .postGetDivisions()
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getProfiles(requestAction: RequestActionDTO) {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .postGetProfiles(requestAction)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getBrands(requestBrand: RequestBrandDTO) {
    return new Promise<ResponseBrandDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .postGetBrands(requestBrand)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public searchUsers(requestUserFilter: RequestUsersByFilterDTO) {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .postSearchUsers(requestUserFilter)
        .toPromise()
        .then(
          (data: CommonDataDTO[]) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public searchImpersonatedUsers(userDependenciesRequest: RequestImpersonatedUserDTO) {
    return new Promise<ResponseImpersonatedUserDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .postGetImpersonatedUserSearch(userDependenciesRequest)
        .toPromise()
        .then(
          (data: ResponseImpersonatedUserDTO[]) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getDetailUser(requestDetailUser: RequestDetailUsersDTO) {
    return new Promise<ResponseDetailUsersDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetDetailUser(requestDetailUser)
        .toPromise()
        .then(
          (data: ResponseDetailUsersDTO) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getUserDetailByUserId(requestUserDetail: UserDetailRequestDTO) {
    return new Promise<UserDetailResponseDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetUserDetailByUserId(requestUserDetail)
        .toPromise()
        .then(
          (data: UserDetailResponseDTO) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getUserDetailByUserName(requestUserDetail: UserDetailRequestDTO) {
    return new Promise<UserDetailResponseDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetUserDetailByUserName(requestUserDetail)
        .toPromise()
        .then(
          (data: UserDetailResponseDTO) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getPasswordWS() {
    return new Promise<ResponsePasswordDTO>((resolve, reject) => {
      this.adminServiceApi
        .postGetPasswordWS()
        .toPromise()
        .then(
          (data: ResponsePasswordDTO) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getUserTypes() {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .postGetUserType()
        .toPromise()
        .then(
          (data: CommonDataDTO[]) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getAttributionsProfile(requestActtributions: RequestAttributionsByProfileDTO) {
    return new Promise<ResponseAttributionsByProfileDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .postGetAttributions(requestActtributions)
        .toPromise()
        .then(
          (data: ResponseAttributionsByProfileDTO[]) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getVendors(requestVendor: RequestVendorByFilterDTO) {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .postGetVendors(requestVendor)
        .toPromise()
        .then(
          (data: CommonDataDTO[]) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public deleteUser(requestDelete: RequestDeleteUsersDTO) {
    return new Promise<boolean>((resolve, reject) => {
      this.adminServiceApi
        .postDeleteUser(requestDelete)
        .toPromise()
        .then(
          (data: boolean) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public modifyUser(requestModifyUser: RequestModifyUsersDTO) {
    return new Promise<boolean>((resolve, reject) => {
      this.adminServiceApi
        .postModifyUser(requestModifyUser)
        .toPromise()
        .then(
          (data: boolean) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public createUser(requestCreateUser: RequestCreateUsersDTO) {
    return new Promise<boolean>((resolve, reject) => {
      this.adminServiceApi
        .postCreateUser(requestCreateUser)
        .toPromise()
        .then(
          (data: boolean) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  getProfilesAdminReport(typeBs?: string) {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .getProfilesByTypeBs(typeBs)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => reject(error)
        );
    });
  }

  getOffices(division: string) {
    return new Promise<CommonDataDTO[]>((resolve, reject) =>
      this.adminServiceApi
        .getOffices(division)
        .toPromise()
        .then((value) => (value ? resolve(value) : reject(value)))
        .catch((error) => reject(error))
    );
  }

  getChainsWithoutMacrochain(division: string) {
    return new Promise<CommonDataDTO[]>((resolve, reject) =>
      this.adminServiceApi
        .getChainsWithoutMacrouser(division)
        .toPromise()
        .then((value) => (value ? resolve(value) : reject(value)))
        .catch((error) => reject(error))
    );
  }

  getOfficesByMacrouser(macrouser: string) {
    return new Promise<CommonDataDTO[]>((resolve, reject) =>
      this.adminServiceApi
        .getOfficesByMacrouser(macrouser)
        .toPromise()
        .then((value) => (value ? resolve(value) : reject(value)))
        .catch((error) => reject(error))
    );
  }

  getChainsByMacrouser(macrouser: string) {
    return new Promise<CommonDataDTO[]>((resolve, reject) =>
      this.adminServiceApi
        .getChainsByMacrouser(macrouser)
        .toPromise()
        .then((value) => (value ? resolve(value) : reject(value)))
        .catch((error) => reject(error))
    );
  }

  getProfilesByUserType(id: string) {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.adminServiceApi
        .getProfilesByUserType(id)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => reject(error)
        );
    });
  }
}
